var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-section planning__body-block flex-box flex-column"},[(_vm.loading)?_c('div',{staticClass:"loading py-5"},[_c('Loading')],1):_vm._e(),_c('div',{attrs:{"id":"dashboardContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }